import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-tab-page-ui',
    templateUrl: './bb-tab-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TabPageComponent {
  onTabSelect(index: number) {
    console.log(`Selected tab with index: ${index}`);
  }
}
